'use client';

export const SUPPORTED_MODEL_KEYS = [
  'sora-2-async',
  'sora-2-async-remix',
  'veo',
  'veo-special',
  'doubao-seedance',
] as const;

export type SupportedModelKey = (typeof SUPPORTED_MODEL_KEYS)[number];

export const MODELS_WITH_HIDDEN_DESCRIPTION = new Set<SupportedModelKey>(['sora-2-async', 'veo', 'veo-special']);

export const isSupportedModelKey = (value: string | null | undefined): value is SupportedModelKey =>
  SUPPORTED_MODEL_KEYS.includes(value as SupportedModelKey);
